/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReportRunMetricsResponseReportRunMetricResult } from './ReportRunMetricsResponseReportRunMetricResult';
import {
  ReportRunMetricsResponseReportRunMetricResultFromJSON,
  ReportRunMetricsResponseReportRunMetricResultFromJSONTyped,
  ReportRunMetricsResponseReportRunMetricResultToJSON,
  ReportRunMetricsResponseReportRunMetricResultToJSONTyped,
} from './ReportRunMetricsResponseReportRunMetricResult';

/**
 *
 * @export
 * @interface ApiReportRunMetricsResponse
 */
export interface ApiReportRunMetricsResponse {
  /**
   *
   * @type {Array<ReportRunMetricsResponseReportRunMetricResult>}
   * @memberof ApiReportRunMetricsResponse
   */
  results?: Array<ReportRunMetricsResponseReportRunMetricResult>;
}

/**
 * Check if a given object implements the ApiReportRunMetricsResponse interface.
 */
export function instanceOfApiReportRunMetricsResponse(
  value: object,
): value is ApiReportRunMetricsResponse {
  return true;
}

export function ApiReportRunMetricsResponseFromJSON(json: any): ApiReportRunMetricsResponse {
  return ApiReportRunMetricsResponseFromJSONTyped(json, false);
}

export function ApiReportRunMetricsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiReportRunMetricsResponse {
  if (json == null) {
    return json;
  }
  return {
    results:
      json['results'] == null
        ? undefined
        : (json['results'] as Array<any>).map(
            ReportRunMetricsResponseReportRunMetricResultFromJSON,
          ),
  };
}

export function ApiReportRunMetricsResponseToJSON(json: any): ApiReportRunMetricsResponse {
  return ApiReportRunMetricsResponseToJSONTyped(json, false);
}

export function ApiReportRunMetricsResponseToJSONTyped(
  value?: ApiReportRunMetricsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    results:
      value['results'] == null
        ? undefined
        : (value['results'] as Array<any>).map(ReportRunMetricsResponseReportRunMetricResultToJSON),
  };
}
